import { validate as uuidValidate } from "uuid";
import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

/* ──────────────────────────────────────────────────────────────
 * 📦 getProjectFileTree (NULL-SAFE)
 *  - 특정 사용자의 특정 프로젝트 트리 구조 조회 API
 *  - projectId UUID 검증 통과 시에만 요청
 *  - ✅ 401이면 authFetch가 refresh 후 1회 재시도
 * ────────────────────────────────────────────────────────────── */
export async function getProjectFileTree(userId, projectId) {
  try {
    // STEP 0 : projectId 사전 검증
    if (!projectId || !uuidValidate(projectId) || !userId) {
      console.warn(
        "[SKIP] getProjectFileTree 호출 생략 - 유효하지 않은 프로젝트 아이디 || 유저 아이디 ",
        {
          projectId,
          type: typeof projectId,
        },
      );

      return { success: false, message: "선택된 프로젝트가 없습니다." };
    }

    // ✅ STEP 1 : 요청 경로(path)
    const path = `${BACKEND_URL}/project/${projectId}/file_tree`;

    // STEP 2 : Fetch (✅ authFetch로 교체)
    const res = await authFetch(
      path,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      {
        // 기존 값 유지
        refreshUrlIncludes: "auth/refresh",
      },
    );

    // STEP 3 : 응답 JSON 파싱
    const result = await res.json().catch(() => null);

    if (!result) {
      return { success: false, message: "서버 응답 파싱 실패" };
    }

    if (res.status === 401) {
      return {
        success: false,
        message: "인증이 만료되었습니다. 다시 로그인해 주세요.",
      };
    }

    // STEP 4 : 응답 검증
    if (!res.ok || !result.success) {
      console.warn(
        "⚠️ getProjectFileTree 실패:",
        result?.message || "조회 실패",
      );
      return { success: false, message: result?.message || "조회 실패" };
    }

    // STEP 5 : 성공
    return { success: true, data: result.data ?? result };
  } catch (error) {
    console.error("❌ getProjectFileTree 요청 실패:", error);
    return {
      success: false,
      message: error.message || "서버 요청 중 오류가 발생했습니다.",
    };
  }
}
